module.exports = __webpack_public_path__ + "e006579c101b01447e2d2d868c167d4e.svg";